<template>
  <div id="remit">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        style="padding: 0 5px"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div
                  style="max-height: 200px;overflow-y: auto; float: left;
                    width: calc(100% - 59px);"
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpand || index < 10) &&
                          item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="margin: 0 0 0 16px; cursor: pointer; color: #409eff;float:left;"
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="是否下载：" prop="downFlag">
                <el-select
                  clearable
                  v-model="form.downFlag"
                  placeholder="请选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option label="是" value="1"> </el-option>
                  <el-option label="否" value="0"> </el-option>
                </el-select>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="下载时间：">
                <el-date-picker
                  size="small"
                  v-model="downloadTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="汇出时间：">
                <el-date-picker
                  size="small"
                  v-model="remitTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24"
            ><div class="grid-content bg-purple" style="text-align: right">
              <el-button size="small" type="primary" @click="getList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </div></el-col
          >
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <div style="overflow: hidden">
        <div class="left">
          <el-button
            v-if="false"
            type="primary"
            size="small"
            @click="batchDownLoad"
            >批量下载</el-button
          >
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="getList"
        />
      </div>

      <el-table :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column
          label="汇出编号"
          width="175px"
          align="center"
          prop="remitId"
        />
        <el-table-column
          label="汇出时间"
          align="center"
          prop="remitTime"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.remitTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="platNo == '09'"
          label="汇出模板"
          align="center"
          prop="templateName"
        />
        <el-table-column
          label="汇出产品数"
          align="center"
          prop="remitProductNum"
        />
        <el-table-column label="汇出SKU数" align="center" prop="remitSkuNum" />
        <el-table-column label="所属店铺" align="center" prop="shopName" />
        <el-table-column
          label="操作人"
          align="center"
          prop="nickName"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.nickName ? scope.row.nickName : scope.row.operNo }}
          </template>
        </el-table-column>
        <el-table-column
          label="下载时间"
          align="center"
          prop="downTime"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.downTime }} </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleDownload(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="下载文件名称设置"
      width="35%"
      :visible.sync="noteDialogVisible"
      class="note-dialog"
    >
      <el-row style="display: flex; align-items: center">
        <el-col :span="2">
          <p>文本名称规则:</p>
        </el-col>
        <el-col :span="22">
          <el-input v-model="form.remark" type="textarea" :rows="6"> </el-input>
        </el-col>
      </el-row>
      <el-row style="display: flex; align-items: center; padding-left: 50px">
        1、下载文件名称可以由变量和常量组成，如设置文件名称：Amz-{StoreName}-{DownloadDate}-{RecordNumber}，下载后文件名称为：Amz-小明精品FBA店-2020220-C7PQ6KK.xlsx；
        <br />2、设置后的文件名称，仅对新下载的文件有效；
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noteDialogVisible = false" size="small"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submitRemark(form.remark)"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {loadZdxz,loadSmxs,updateAmazonRemark,singledeleteAmazon,batchDeleteByIDs,batchdeleteAmazon,getTreeList,lowerShelfProduct,loadRemit,exportRemit} from '@/api/product/amazon'
import {getTree} from '@/api/tree/tree';
import { downLoadExcel } from "@/utils/zipdownload";
import { getRemitList } from "@/api/template/universal";
import { getShopList } from "@/api/system/shopManage";
import { mapGetters } from "vuex";

export default {
    name: "onLine",
    components:{Breadcrumb},
    data() {
        return {
            total: 0,
            currentPage: 1,
            pickerOptions: {},
            form: {
              pageNum: 1,
              pageSize: 10,
              downFlag: '',
              shopId: [],
              downFlag: '',
              platNo: ''
              // shopId:'',
              // isDownload: null,
              // beginTime: '',
              // endTime: '',
              // downBeginTime: '',
              // downEndTime: ''
            },
            downloadTime: null,
            remitTime: null,
            tableData: [],
            noteDialogVisible: false,
            shopList: [],
            isCheckShop: true,
            isExpand: false,
            shopName: '',
            platNo: ''
        }

    },
    computed:{
        treeId(){
            return this.$route.query.treeId;
        },
          ...mapGetters(["dictData", "dictMap"]),
           routeName() {
      return this.$route.path
    },
    },
    watch:{
        treeId(){
            this.dateValue=null;
            this.getList()
        },
           routeName() {
            this.getShopList()
      this.getList()
    },
    },
    created() {
        this.getList();
        this.getShopList();
    },
    methods: {
        getShopList(){
          let path = this.$route.path
          let platNo = ""
            if(path.indexOf('shopfiy') > -1){
              platNo = '06'
            } else if(path.indexOf('shopline') > -1){
              platNo = '07'
            }else if(path.indexOf('shoplazza') > -1){
              platNo = '08'
            }else if(path.indexOf('lazada') > -1){
              platNo = '03'
            }else if(path.indexOf('shopee') > -1){
              platNo = '05'
            } else {
              platNo = ''
            }
          getShopList({platNo }).then((res) => {
            this.shopList = res.rows
            // this.handleChangeShop()
          })
        },
         handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
        batchDownLoad() {
            this.noteDialogVisible = true;
        },
        turnWay(e){
            var classVal =  e.target.className;
            if(classVal == 'el-icon-caret-top'){
                e.target.setAttribute('class','el-icon-caret-bottom');
                this.form.byAsc = 'desc';
            }else{
                e.target.setAttribute('class','el-icon-caret-top');
                this.form.byAsc = 'asc';
            }
            this.getListZz();
        },
        loadNode(node, resolve) {
            var that =this;
            if (node.level === 0) {
                //查询顶级节点
                let params = {};
                getTreeList(params).then(function(res){
                    that.treeData = that.createTreeData(res.data);
                    return resolve(that.treeData);
                }).catch(function(error){
                    this.$message.error(res.msg);
                });
            }else {
                let params = {pTypeNo:node.data.id};
                // 根据父节点id找寻下一级的所有节点
                getTreeList(params).then(res => {
                    return resolve(res.data);
                });
            }

        },

        createTreeData(data){
            let treedata = data.filter(father =>{
                if(father['pTypeNo'] == ""||father['pTypeNo'] == null){
                    father['pTypeNo'] = '0'
                }
                let childArr = data.filter(child =>{
                    return  child['pTypeNo'] == father.id;
                });
                childArr.length > 0?father.children =childArr:'';
                return father['pTypeNo'] == '0';
            });
            return treedata ;
        },

        setClassManage:function(){
            this.classManageDialog = true;
        },

        closeCMDialog_f:function(){
            this.classManageDialog = false;
        },
        show: function() {

        },
        showMoreSearchItem:function(){
            this.showMoreItem = !this.showMoreItem;
        },
        cancle_1:function(){
            this.showMoreItem = false;
        },

        loadSku(tree, treeNode, resolve){
            var xalist =[]

            for (var i =0 ; i<tree.sAmazonSku.length;i++){
                var  aa=
                {
                    bzxs:false,
                    dpxs:false,
                    cz:false,
                    zcd:true,
                    fcd:false,
                    pId: tree.sAmazonSku[i].skuid,
                    mainPic: tree.mainPic,
                    proTitle:tree.proTitle,
                    skuno:tree.sAmazonSku[i].skuno,
                    aSite:tree.aSite,
                    price:tree.sAmazonSku[i].price,
                    invent:tree.sAmazonSku[i].invent,
                    createTime:tree.createTime,
                    updateTime:tree.updateTime
                }
                xalist.push(aa);
            }
            resolve(xalist)
        },

        getList: function() {
            this.startLoading()
            let form = this._.clone(this.form)
            form.shopId = form.shopId.join(',')

            let path = this.$route.path
            if(path.indexOf('shopfiy') > -1){
              form.platNo = '06'
            } else if(path.indexOf('shopline') > -1){
              form.platNo = '07'
            }else if(path.indexOf('shoplazza') > -1){
              form.platNo = '08'
            }else if(path.indexOf('lazada') > -1){
              form.platNo = '03'
            }else if(path.indexOf('shopee') > -1){
              form.platNo = '05'
            }else {
              form.platNo = '09'
            }
            this.platNo = form.platNo

            if (this.downloadTime !=null){
                form.downTimeBegin=this.downloadTime[0];
                form.downTimeEnd=this.downloadTime[1];
            } else{
              form.downTimeBegin=  undefined
                form.downTimeEnd= undefined
            }

            if (this.remitTime !=null){
              form.beginTime=this.remitTime[0];
              form.endTime=this.remitTime[1];
            } else{
              form.beginTime=  undefined
              form.endTime=  undefined
            }

            getRemitList(form).then((res) => {
                console.log(res);
                this.tableData = res.rows;
                this.total = res.total;
                this.$store.dispatch('setIfReload',true);
                this.endLoading()
            })
        },
        async handleDownload(row) {
          this.startLoading()
          let method = 'exportRemit'
          let path = this.$route.path
          if(path.indexOf('shopfiy') > -1 || path.indexOf('shopline') > -1 || path.indexOf('shoplazza') > -1){
            method = 'exportTemplateRemit'
          }

          downLoadExcel(`/server/universal/template/${method}?remitId=${row.remitId}&fileName=` + Math.random(), Math.random()).then(()=>{
            this.getList()
            this.endLoading()
          })
        },
        getZdxz: function() {
            this.startLoading()
            loadZdxz().then((res) => {
                this.dpzdxzList = res.rows;
                this.endLoading()
            })
        },
        getSmxs: function() {
            this.loading = true;
            loadSmxs().then((res) => {
                this.dpsmxsList = res.rows;
                this.endLoading()
            })
        },


        setDownLoadFileName(){
            this.noteDialogVisible=true
        },


        //提交备注
        submitRemark(remark){
            updateAmazonRemark(this.form).then((res) => {
                if (res.code === 200) {
                    this.msgSuccess("修改成功");
                    this.getList();
                    this.noteDialogVisible = false;
                }
            })
        },

        batchHandle: function(val) {
            if ("1" == val) {
                //将亚马逊平台商品同步到本平台

            } else if("2"== val) {
                // this.batchUpdate();
                this.batchLowerShelfProduct();
            }else {
                this.batchDelete();
            }
        },
        //批量删除
        batchDelete() {
            const ids =this.ids;
            this.$confirm('是否确认删除选择的' + this.ids.length + '条数据项?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
                return batchdeleteAmazon(ids);
            }).then(() => {
                this.getList();
                this.msgSuccess("删除成功");
            }).catch(function() {});
        },
//            批量待发布
        batchUpdate() {
            const shopeeList = this.shopeeList;
            if (this.shopeeList.length==0){
                this.msgError("批量待发布至少选择一条数据");
                return
            }
            this.$confirm('是否确认把这' + this.shopeeList.length + '条数据项批量移入待发布', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
                return batchDeleteByIDs(JSON.stringify(shopeeList));
            }).then(() => {
                this.getList();
                this.msgSuccess("修改成功");
            }).catch(function() {});
        },

        //用户勾选
        handleSelectionChange(val) {
            this.ids=[];
            this.shopeeList=[];
            //获取当前用户
            var userName = this.$store.state.user.name;
            val.forEach((item) => {
                //批量移入待发布
                var updateStatePara={
                    "pId":item.pId,
                    "pubStatus":'01',
                    "operNo":userName,

                };
                this.ids.push(item.pId);
                this.shopeeList.push(updateStatePara);

            });
        },

        foramtDataSource(val){
            if(val == '01'){
                return "1688";
            }else if(val == '02'){
                return "速卖通";
            }else if(val == '03'){
                return "Lazada";
            } else if(val == '04'){
                return "Amazon";
            } else if(val == '05'){
                return "Shopee";
            }
            return "未知";
        },


        handleSizeChange: function(val) {
            console.log(`每页: ${val}条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        edit: function(row) {
            this.$router.push({path: "/product/amazon/onLineEdit", query: {pId: row.pId}})
        },
        deleteRow(row) {
//                let pId = row.pId;
            this.$confirm('是否确认删除Amazon产品标题为<span style="color: red">' + row.proTitle + '</span>的数据项?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                //显示HTML
                dangerouslyUseHTMLString: true,
                type: "warning"
            }).then(function() {
                return singledeleteAmazon(row.pId);
            }).then(() => {
                this.getList();
                this.msgSuccess("删除成功");
            }).catch(function() {});
        },
        //清空表单
        resetForm(){
            // this.$refs['form'].resetFields();
            this.form.shopId = []
            this.form.downFlag = ''
            this.downloadTime = null
            this.remitTime = null

            this.dateValue=null;
            this.dateValue2=null;
        },
        //移动分类树形数据
        getMoveClassification(that){
            getTree().then((res) => {
                this.ydlfTree.treeData=res.data;
            })
        },
        //批量下架产品
        batchLowerShelfProduct(){
            var length = this.ids.length;
            var join = this.ids.join("-");
            if (length <=0){
                this.msgError("请选择需要下架的产品");
                return;
            }
            this.$confirm('是否确认把这'+length+'条产品下架?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
                return lowerShelfProduct(join);
            }).then(() => {
                this.getList();
                this.msgSuccess("下架产品成功");
            }).catch(function() {});
        },
        importDefiMode(){

        },
        addSysTem(){

        },
        addDefiOrder(){

        }
    },
    mounted() {

    }
}
</script>

<style scoped>
@import "../../../assets/css/product.css";
#ready-release {
  width: 100%;
}
.detailForm {
  padding-top: 5px;
  margin-left: 85px;
  width: 50%;
  height: auto;
  margin-bottom: 8px;
}
.detailForm .el-form-item,
.sea_cont {
  margin-bottom: 10px !important;
}
.double_item .el-form-item {
  margin-bottom: 0px !important;
}
.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
